export default "__VITE_ASSET__COJHdnMZ__"